module.exports = __webpack_public_path__ + "static/media/posta_poruba_8_(3).e992c0da.jpg";